import { createSlice } from "@reduxjs/toolkit";
import { ICustomExtraCharge } from "store/api/types";

interface OptionsState {
  options: string[];
  checkedOptions: string[];
  customOptions: ICustomExtraCharge[];
  customCheckedOptions: ICustomExtraCharge[];
  firstCustomOptions: boolean;
}

const initialState: OptionsState = {
  options: [],
  checkedOptions: [],
  customOptions: [],
  customCheckedOptions: [],
  firstCustomOptions: false,
};

export const optionsSlice = createSlice({
  name: "options",
  initialState,
  reducers: {
    setOptions: (state, { payload }) => {
      state.options = payload;
    },
    setCheckedOptions: (state, { payload }) => {
      state.checkedOptions = payload;
    },
    setCustomOptions: (state, { payload }) => {
      state.customOptions = payload;
    },
    setCustomCheckedOptions: (state, { payload }) => {
      state.customCheckedOptions = payload;
    },
    setFirstCustomOptions: (state, { payload }) => {
      state.firstCustomOptions = payload;
    },
  },
});

export const {
  setOptions,
  setCheckedOptions,
  setCustomOptions,
  setCustomCheckedOptions,
  setFirstCustomOptions,
} = optionsSlice.actions;
export default optionsSlice.reducer;
